import { PagePost, PageSection, PagesSections } from '../types/api-types';
import { objectToFiltersQuery } from '../utils/objectToFiltersQuery';
import { BaseOrganizationEndpoints } from './base';

export type PageSectionUpdatePayload = Partial<Omit<PageSection, 'pages'>> & {
  pages?: Partial<PagesSections>[];
};
export type PageSectionAddPayload = Omit<PageSectionUpdatePayload, 'id'>;

export interface PageSectionFilter {}
export interface PageFilter {
  id?: string;
  section_ids?: string[];
  section_id?: string;
}

export class Pages extends BaseOrganizationEndpoints {
  async getSections() {
    return this.requestWithStatus<PageSection[]>('GET', '/v1/sections');
  }

  async updateSection(id: string, section: PageSectionUpdatePayload) {
    return await this.requestWithStatus<PageSection[]>(
      'PUT',
      `/v1/sections/${id}`,
      { ...section, id }
    );
  }

  async deleteSection(idSection: string) {
    return this.requestWithStatus<PageSection[]>(
      'DELETE',
      `/v1/sections/${idSection}`
    );
  }

  async deletePage(idPage: string) {
    return this.requestWithStatus<PageSection[]>(
      'DELETE',
      `/v1/pages/${idPage}`
    );
  }

  async createSection(section: PageSectionAddPayload) {
    return this.requestWithStatus<PageSection>('POST', '/v1/sections', section);
  }

  async getPages(filters?: PageFilter) {
    return this.requestWithStatus<PagePost[]>(
      'GET',
      '/v1/pages' + objectToFiltersQuery(filters)
    );
  }

  async getPage(pageFilters: PageFilter) {
    if (!pageFilters.id) throw new Error('Page ID is required');
    return await this.requestWithStatus<PagePost>(
      'GET',
      `/v1/pages/${pageFilters.id}`
    );
  }

  async createPage(post: Partial<PagePost>) {
    return this.requestWithStatus<PagePost>('POST', '/v1/pages', post);
  }

  async updatePage(idPost: string, post: Partial<PagePost>) {
    return this.requestWithStatus<PagePost>('PUT', `/v1/pages/${idPost}`, post);
  }
}
